import v from 'components/variables';

export const DEFAULT = 'default';
export const PLAYING = 'playing';
export const PLAYED = 'played';

export const TTS_STOP = 0;
export const TTS_PLAY_ALL = 1;
export const TTS_PLAY_ONE = 2;

export const JOBS = [
  { emoji: '👨🏼‍🌾', color: v.tealExtraLight },
  { emoji: '👷🏽‍♀️', color: v.purpleExtraLight },
  { emoji: '👨🏽‍🎨', color: v.yellowExtraLight },
  { emoji: '👩🏾‍💼', color: v.blueExtraLight },
  { emoji: '🧑🏻‍🏫', color: v.orangeExtraLight },
  { emoji: '👩🏾‍🚒', color: v.redExtraLight },
  { emoji: '👩🏽‍⚖️', color: v.violetExtraLight },
  { emoji: '👩🏻‍⚕️', color: v.greenExtraLight },
  { emoji: '👨🏿‍🔬', color: v.violetExtraLight },
  { emoji: '👮🏾‍♂️', color: v.tealExtraLight },
  { emoji: '👩🏽‍💻', color: v.blueExtraLight },
  { emoji: '👩🏻‍✈️', color: v.redExtraLight },
  { emoji: '👨🏾‍🍳', color: v.yellowExtraLight },
  { emoji: '👩🏼‍🏭', color: v.greenExtraLight },
  { emoji: '👨🏽‍🚀', color: v.purpleExtraLight },
  { emoji: '👩🏼‍🔧', color: v.orangeExtraLight },
];

export const PLAN_STATUSES = {
  NOT_STARTED: 'NOT_STARTED',
  NOT_SUBMITTED: 'NOT_SUBMITTED',
  APPROVED: 'APPROVED',
  NOT_APPROVED: 'NOT_APPROVED',
  BLOCKED: 'BLOCKED',
};
